import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PhoneUtilsService {

    constructor() {
    }

    addCustomPhoneCode(instance: any, phoneInstance: string | null): string | null {
        let inputNumber = instance.getNumber();
        let expectedPrefix = '+38077';
        let digitsOnly = inputNumber.replace(/\D/g, '');
        let isValidLength = digitsOnly.length == 12;
        let isCustomPrefix = inputNumber.startsWith(expectedPrefix);

        let isValidCustomCode = !instance.isValidNumber() && isCustomPrefix && isValidLength;

        if (isValidCustomCode) {
            return inputNumber;
        }

        return phoneInstance;
    }

}
